module.exports = __webpack_public_path__ + "fonts/iconfont.587fb15.ttf";